const districtCenterCoords = {
  Личаківський: {
    coords: { lat: 49.83849689736815, lng: 24.055647120483545 },
    zoom: 15,
  },
  Шевченківський: {
    coords: { lat: 49.86188774420238, lng: 24.007830558610068 },
    zoom: 15,
  },
  Франківський: {
    coords: { lat: 49.82006880162025, lng: 24.003219744055176 },
    zoom: 15,
  },
  Залізничний: {
    coords: { lat: 49.830208130690146, lng: 23.971229120694872 },
    zoom: 15,
  },
  Галицький: {
    coords: { lat: 49.84095068210214, lng: 24.0269864985622 },
    zoom: 15,
  },
  Сихівський: {
    coords: { lat: 49.80042925475536, lng: 24.050271302808547 },
    zoom: 15,
  },
  multi: {
    coords: { lat: 49.841328, lng: 24.031592 },
    zoom: 15,
  },
};

export default districtCenterCoords;
